export default __webpack_public_path__ + "static/media/inner4.38c14f2f.jpg";